import { actionCreator } from "src/store/dataService/actions/utils/actionCreator";
import { API } from "src/store/dataService/types";
import { CreditAppSettings } from "Types/creditApp";

/**
 * Get request/success/failure
 */
export const getCreditAppSettingsRequest = actionCreator(
    "credit_app_settings/get/request",
    (creditApiUrl: string, creditAppDealerId: string, afterFetch?: () => void) => ({
        creditApiUrl,
        creditAppDealerId,
        afterFetch,
    }),
    () => ({ route: API.CreditApp })
);

export const getCreditAppSettingsSuccess = actionCreator(
    "credit_app_settings/get/success",
    (settings: Omit<CreditAppSettings, "loaded">) => ({
        settings,
    })
);

export const getCreditAppSettingssFailure = actionCreator("credit_app_settings/get/failure");
